<template>
  <f-form
    store="@freebe/entrepreneurs"
    :id="id"
  >
    <template #default="{ item }">
      <div class="is-grid">
        <f-field 
          class="is-col-3 is-aligned"
          label="A l'ACRE ?"
          inline
        >
          <f-toggle 
            v-model="item.activity.accre.chosen"
            :readonly="!canEdit"
          ></f-toggle>
        </f-field>

        <!-- <span class="is-col-9"></span> -->

        <f-field 
          class="is-col-3 is-aligned"
          label="A l'impôt libératoire ?"
          inline
        >
          <f-toggle 
            v-model="item.activity.tax_option.chosen"
            :readonly="!canEdit"
          ></f-toggle>
        </f-field>

        <!-- <span class="is-col-9"></span> -->

        <div class="is-col-12">
          <!-- <hr> -->
        </div>

        <f-field 
          class="is-col-3"
          label="Date de début d'ACRE"
        >
          <f-datepicker 
            v-model="item.activity.accre.since"
            :readonly="!canEdit"
            long
          ></f-datepicker>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Date de fin d'ACRE"
        >
          <f-datepicker 
            v-model="item.activity.accre.until"
            :readonly="!canEdit"
            long
          ></f-datepicker>
        </f-field>

        <f-field 
          class="is-col-6"
          label="Années avec l'impôt libératoire"
        >
          <f-select 
            v-model="item.activity.tax_option.years"
            :options="activityYears"
            :multiple-label-max="6"
            :readonly="!canEdit"
            multiple
            long
          ></f-select>
        </f-field>

        <f-field
          class="is-col-3"
          label="Taux de CFP"
        >
          <f-select
            v-model="cfp"
            :options="cfpRates"
            :readonly="!canEdit"
            value="amount"
            label="name"
            long
          ></f-select>
        </f-field>

        <f-field
          class="is-col-3"
          label="Taux de TFC"
        >
          <f-select
            v-model="tfc"
            :options="tfcRates"
            :readonly="!canEdit"
            value="amount"
            label="name"
            long
          ></f-select>
        </f-field>
      </div>
    </template>
  </f-form>
</template>

<script>
  import { computed, reactive, watch, toRefs } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import { useConstants } from '@freebe/sdk/constants'
  import useRoles from '@composables/use-roles'

  const Constants = useConstants('taxes')

  export default {
    props: {
      id: {
        type: String,
        required: true,
      },
    },

    setup (props) {
      const { get, patch } = useStore('@freebe/entrepreneurs')
      const { checkPermissions } = useRoles()
      
      const canEdit = computed(() => 
        checkPermissions('freebe/entrepreneurs:patch')
      )

      const entrepreneur = computed(() =>
        get(props.id)
      )

      const state = reactive({
        cfp: entrepreneur.value.activity.custom_taxes.find(({ type }) => 
          type === Constants.type.cfp
        )?.amount,
        tfc: entrepreneur.value.activity.custom_taxes.find(({ type }) => 
          type === Constants.type.tfc
        )?.amount,
        cfpRates: computed(() => 
          [{ name: 'Supprimer', amount: null }, ...Constants.rates.cfp]
        ),
        tfcRates: computed(() => 
          [{ name: 'Supprimer', amount: null }, ...Constants.rates.tfc]
        ),
        creationDate: computed(() =>
          entrepreneur.value?.creation?.date
        ),
        activityYears: computed(() => {
          const start = new Date(state.creationDate).getFullYear()
          const end = new Date().getFullYear()

          return new Array(end - start + 1).fill(0).map((_, index) => index + start)
        }),
      })

      function updateCustomRate (taxType) {
        return newValue => {
          const { _id, activity } = entrepreneur.value

          let data = {}

          if (newValue === null) {
            data = {
              activity: {
                ...activity,
                custom_taxes: activity.custom_taxes.filter(({ type }) => 
                  type !== taxType
                )
              }
            }
          } else {
            const customTaxes = [...activity.custom_taxes]
            const index = customTaxes.findIndex(({ type }) => 
              type === taxType
            )

            if (index == -1) {
              customTaxes.push({
                name: Constants.names[taxType],
                amount: newValue, 
                type: taxType
              })
            } else {
              customTaxes.splice(index, 1, {
                name: Constants.names[taxType],
                amount: newValue, 
                type: taxType
              })
            }
            
            data = {
              activity: {
                ...activity,
                custom_taxes: customTaxes,
              }
            }
          }

          patch(_id, data, { local: true })
        }
      }

      watch(() => state.cfp, updateCustomRate(Constants.type.cfp))

      return {
        ...toRefs(state),
        canEdit,
      }
    },
  }
</script>